module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title1"
  }, [_vm._v("COACH")]), _vm._v(" "), _c('p', {
    staticClass: "title1a"
  }, [_c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("RUN")])]), _vm._v(" "), _c('p', {
    staticClass: "title1b"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("WIN")])]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_vm._v("A COMPREHENSIVE GUIDE TO")]), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Coaching High School Cross Country, Running Fast, and Winning Championships")])]), _vm._v(" "), _c('p', {
    staticClass: "title4"
  }, [_vm._v("KEN SAYLES")]), _vm._v(" "), _c('p', {
    staticClass: "title5"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("2014 Southern California “Coach of the Year”")])]), _vm._v(" "), _c('p', {
    staticClass: "publisheri"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pub.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_vm._v("NEW YORK")]), _vm._v(" "), _c('p', {
    staticClass: "publishers"
  }, [_vm._v("LONDON • NASHVILLE • MELBOURNE • VANCOUVER")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5c1d2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/title.vue
// module id = 63
// module chunks = 0